import React from 'react'

import { Looks } from '@Components/Looks'
import { useTileSettings } from '@Components/Tiles/settings'
import {
  LookListBlock as LookListBlockGraphQL,
} from '@Generated/graphql'
import { BlockContext } from '@Globals/CMS/Context'
import { Trans } from '@Globals/Translations'

const LookListBlock = ({
  data,
  id,
}: {
  data: LookListBlockGraphQL
  id?: string
}) => {
  const { presentation } = React.use(BlockContext)
  const { appearance, common, looks, settings } = data
  const tileSettings = useTileSettings(settings)

  if (!looks || looks.length === 0) {
    return null
  }

  let titleOverride: React.ReactNode | undefined
  if (tileSettings.type === 'ambassador' && common?.title) {
    titleOverride = (
      <Trans
        components={{
          /* eslint-disable react/jsx-no-useless-fragment */
          Link: (
            <>
              <></>
              <>{common.title}</>
            </>
          ),
          /* eslint-enable react/jsx-no-useless-fragment */
        }}
        i18nKey="cms:MORE_LOOKS_FROM"
      />
    )
  }

  return (
    <Looks
      appearance={appearance}
      common={common}
      id={id}
      looks={looks}
      noPadding={looks.length === 1 && (tileSettings.version !== '2' || tileSettings.singleLook)}
      presentation={presentation}
      settings={settings}
      titleOverride={titleOverride}
    />
  )
}

export default LookListBlock
